module.exports = __webpack_public_path__ + "static/src/content/images/processed/1000/thurston_promo_custom.7b11ba2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/1000/thurston_promo_custom.jpg
// module id = +vqr
// module chunks = 1